module.exports = __webpack_public_path__ + "assets/tianqi.474683e6.svg";